import styled from 'styled-components';
import { FONTS, SIZE, COLORS } from '@app/src/ui';
import { Assesors } from '../Assesors';
import { Security } from '../Security';

interface Props {
  isDisplay?: boolean;
}

export const Weight = styled.span`
  font-weight: 600;
`;

export const Subtitle = styled.h3`
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 13px;
  margin-bottom: 10px;
  color: #666;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const Wrapper = styled.footer`
  display: ${(props: Props) => props.isDisplay ? 'block' : 'none'};
  font-family: ${FONTS.ROBOTO};
  background: #000;
  color: #aaa;
  font-size: 12px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 12px;
    ${Container} {
      display: flex;
      padding: 24px 15px 30px;
      & > div {
        width: 25%;
        padding: 0 10px;
      }
      & > div:not(:last-child) {
        border-right: 1px solid #252525;
      }
    }
  }
  @media (min-width: ${SIZE.LARGE_DESKTOP}) {
    ${Container} {
      padding: 32px 0;
      & > div:not(:first-child) {
        padding: 0 0 0 40px;
      }
    }
  }
`;

export const SecurityWrapper = styled(Security)`
  background: #fff;
  color: ${COLORS.BLACK};
  padding: 15px 0 16px;
  width: 100%;
  min-width: 200px;
  text-align: center;
  a:nth-child(4) {
    margin-left: 2px;
  }
  img {
    width: 55px;
    height: 34px;
  }
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0;
    width: auto;
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    span {
      display: inline-block;
      margin: 0 15px 0 0;
    }
  }
  @media (min-width: ${SIZE.TABLET_BREAK}) {
    text-align: left;
    font-weight: 600;
    a:nth-child(4) {
      margin-left: 8px;
    }
    img {
      width: 65px;
      height: 40px;
    }
  }
`;

export const Legacy = styled.div`
  padding: 15px;
  text-align: center;
  color: #aaa;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin: 0;
    padding: 0;
    font-size: 14px;
    max-width: 180px;
    div {
      margin: 30px 0 25px;
    }
  }
`;

export const Social = styled.div`
  padding: 15px 0 0;
  text-align: center;
  background: #000;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: auto;
    padding: 0;
    text-align: left;
  }
`;

export const Network = styled.a`
  max-width: 220px;
  height: 40px;
  border-radius: 5px;
  background: #32529F;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin: 0 auto;
  cursor: pointer;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 100%;
    margin-left: 0;
  }
`;

export const TermsAndConditions = styled.ul`
  position: relative;
  margin: 0 auto;
  svg {
    position: absolute;
    left: -50px;
  }
  li {
    margin: 0 0 4px;
  }
  a {
    color: #aaa;
    &:hover {
      text-decoration: underline;
    }
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    svg {
      display: none;
    }
    a {
      font-size: 15px;
    }
  }

  @media (min-width: ${SIZE.TABLET_BREAK}) {
    svg {
      display: block;
    }
  }
`;

export const AssesorsWrapper = styled(Assesors)`
  padding: 15px 0;
  width: 100%;
  text-align: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    text-align: left;
    padding: 0;
  }
`;

export const IconFacebookWrapper = styled.span`
  margin-right: 25px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin-right: 4px;
  }
`;

export const CentralHelp = styled.div`
  text-align: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    text-align: left;
  }
`;

export const CentralHelpSubtitle = styled.h3`
  font-family: ${FONTS.ROBOTO_BOLD};
  margin: 0 auto 4px;
  color: #666;
  font-size: 13px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

export const BookLink = styled.a`
  display: inline-block;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin-bottom: 24px;
  }
`;

export const BookImage = styled.img`
  width: 110px;
`;